import { LinkSpec } from '../preset-links/helpers';
import { LinkContainer, LinkSectionView, LinkTitle, StyledLink } from './LinkSection.styles';

interface Props {
  title: string;
  links: LinkSpec[];
}

export const LinkSection = ({ title, links }: Props) => (
  <>
    {links.length !== 0 && (
      <LinkSectionView>
        <LinkTitle>{title}</LinkTitle>

        <LinkContainer>
          {links.map(link => (
            <StyledLink key={`${link.title}-${String(link.url)}`} to={link.url}>
              {link.title}
            </StyledLink>
          ))}
        </LinkContainer>
      </LinkSectionView>
    )}
  </>
);
